import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&display=swap');

:root {
  --plava: #b4d9dc;
  --zelena: #d5ecb6;
  --puder: #f2dad0;
  --zuta: #f8f1a5;
  --koza: #fdc59a;
  --ljubicasta: #dacfe2;
  --roze: #f7c5d8;
  --naslov-siva: #454345;

  /* KONTRASTNE, ISTE NIJANSE, READABLE */
  --bg-plava: #5c8f96;
  --bg-zelena: #7b8f56;
  --bg-puder: #a67c6c;
  --bg-zuta: #998731;
  --bg-koza: #b37442;
  --bg-roze: #a66e86;
  --bg-ljubicasta: #6e5d84;
  --bg-naslov-siva: #f5f5f5;
}


  * {
    margin: 0;
    padding: 0;
    position: relative;
    box-sizing: border-box;

  }

  html {
    scroll-behavior: smooth;
    background: var(--plava);
    font-size: 62.5%; /* 1rem = 10px */
    
    /* RESPONSIVE REM SCALE */
    @media (max-width: 1200px) {
      font-size: 60%; /* 1rem = 9.6px */
    }
    @media (max-width: 992px) {
      font-size: 56.25%; /* 1rem = 9px */
    }
    @media (max-width: 768px) {
      font-size: 50%; /* 1rem = 8px */
    }
    @media (max-width: 480px) {
      font-size: 46.875%; /* 1rem = 7.5px */
    }
  }

  body {
    background: var(--plava);
    font-family: "Lexend", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.6;
    /* overflow-x: hidden; */
    user-select: none;

  }

  h1 {
    font-family: "Lexend", sans-serif;
    font-weight: 900;
  }
  h2 {
    font-family: "Lexend", sans-serif;
    font-weight: 800;
  }
  h3 {
    font-family: "Lexend", sans-serif;
    font-weight: 700;
  }
  h4, h5, h6 {
    font-family: "Lexend", sans-serif;
    font-weight: 600;
  }

  button {
    font-family: "Lexend", sans-serif;
    outline: none;
    user-select: none;
  }

  input, textarea, select {
    font-family: "Lexend", sans-serif;
  }

  img{
    pointer-events: none;
    user-select: none;
  }

a {
  text-decoration: none; 
  color: inherit; 
  }


a:visited,
a:hover,
a:active {
  color: inherit;
  text-decoration: none;
  }

  
  /* Scrollbar Styling */
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background: transparent;
  }


  ::-webkit-scrollbar-thumb {
    background:transparent;
    border-radius: 5px;

    &:hover {
      background:transparent
    }
  }

  /* Sonner Toast Custom Styles */
  [data-sonner-toaster] {
    font-family: 'Lexend', sans-serif !important;
  }

  [data-sonner-toast] {
    background: rgba(69, 67, 69, 0.95) !important;
    backdrop-filter: blur(10px) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    border-radius: 42px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
    color: #f5f5f5 !important;
    padding: 1rem 2rem !important;
    min-width: fit-content !important;
    max-width: fit-content  !important;
    width: fit-content !important;


  }

  [data-sonner-toast][data-type="success"] {
    background: linear-gradient(135deg, var(--bg-zelena), rgba(123, 143, 86, 0.9)) !important;
    border-color: rgba(255, 255, 255, 0.2) !important;
    color: #fff !important;
  }

  [data-sonner-toast][data-type="error"] {
    background: linear-gradient(135deg, #d32f2f, rgba(211, 47, 47, 0.9)) !important;
    border-color: rgba(255, 255, 255, 0.2) !important;
    color: #fff !important;
  }

  [data-sonner-toast][data-type="warning"] {
    background: linear-gradient(135deg, var(--bg-zuta), rgba(153, 135, 49, 0.9)) !important;
    border-color: rgba(255, 255, 255, 0.2) !important;
    color: #fff !important;
  }

  [data-sonner-toast][data-type="info"] {
    background: linear-gradient(135deg, var(--bg-plava), rgba(92, 143, 150, 0.9)) !important;
    border-color: rgba(255, 255, 255, 0.2) !important;
    color: #fff !important;
  }

  [data-sonner-toast] [data-title] {
    color: inherit !important;
    font-weight: 400 !important;
    font-size: 1.4rem !important;
  }

  [data-sonner-toast] [data-description] {
    color: inherit !important;
    opacity: 0.9 !important;
    font-size: 1.2rem !important;
    line-height: 1.4 !important;
  }

  [data-sonner-toast] [data-icon] {
    color: inherit !important;
    width: 2rem !important;
    height: 2rem !important;
  }

  [data-sonner-toast] [data-close-button] {
    background: rgba(255, 255, 255, 0.1) !important;
    color: inherit !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-radius: 6px !important;
    transition: all 0.2s ease !important;
  }

  [data-sonner-toast] [data-close-button]:hover {
    background: rgba(255, 255, 255, 0.2) !important;
    transform: scale(1.05) !important;
  }
`;

export default GlobalStyles;
